import axios from 'axios';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import DemoFileUpload from 'components/orderdetail/DemoFileUpload';
import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Form, InputGroup, Modal, Row, Button, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';

const AddOrderDetailModal = ({ show, setShow }) => {
    const [drugOptions, setDrugOptions] = useState([]);
    const [deliveryDates, setDeliveryDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedDrugs, setSelectedDrugs] = useState([]);
    const [newDrug, setNewDrug] = useState("");
    const [note, setNote] = useState("");
    const [uploadedFile, setUploadedFile] = useState(null);
    const [editableQuantities, setEditableQuantities] = useState({});
    const [docFlag, setDocFlag] = useState(false);
    const [orderTypeValue, setOrderTypeValue] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedFacility, setSelectedFacility] = useState({});
    const [facilitiesData] = useState(JSON.parse(localStorage.getItem("facilitiesData")) || []);
    const [patientOptions, setPatientOptions] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState({ name: 'Select Patient', id: '' });
    const [selectedPatientFlag, setSelectedPatientFlag] = useState(false);
    let orderStatusInternal = JSON.parse(localStorage.getItem("order_status_internal"));
    const [orderStatusList] = useState(orderStatusInternal);
    const [theme, setTheme] = useState(document.documentElement.getAttribute('data-bs-theme') || 'light');
    let delivery_types = JSON.parse(localStorage.getItem("delivery_types"));
    const deliveryTypeOptions = Object.keys(delivery_types).map((key) => ({
        value: key,
        label: delivery_types[key]
    }));

    let orderTypeVal = JSON.parse(localStorage.getItem("order_types"));
    const orderType = [
        { value: "", label: "Select Order Type" },
        ...Object.keys(orderTypeVal)
            .filter(key => orderTypeVal[key] !== "Label Change")
            .filter(key => orderTypeVal[key] !== "DC Medication")
            .map((key) => ({
                value: parseInt(key, 10),
                label: orderTypeVal[key]
            }))
    ];

    const location = useLocation();
    const state = location?.state?.data;
    let initalData = {
        patient_id: state?.patientid,
        delivery_date: '',
        order_type: "",
        note: '',
        orderstatus: '1',
        order_document: {},
        deliveryOn: '1',
        prescriptions: []
    };
    const [formData, setFormData] = useState(initalData);

    useEffect(() => {
        if (show) {
            if (show) {
                const dates = getNextWorkingDays();
                setDeliveryDates(dates);
                if (dates.length > 0) {
                    setSelectedDate(dates[0].value);
                }
            }
        }
    }, [show]);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const currentTheme = document.documentElement.getAttribute('data-bs-theme') || 'light';
            setTheme(currentTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-bs-theme'],
        });

        return () => observer.disconnect();
    }, []);

    const fetchPatientsData = async (id) => {
        let tokenStr = localStorage.getItem("accessToken");
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/patients/list-all-patients/" + id, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        let objData = data.patients.data
        objData.filter(
            (patient) => Number(patient.facility_id) == Number(id)
        );
        let results = [];
        objData.map((value) => {
            results.push({
                id: value.id,
                name: value.last_name + "," + value.first_name,
                facility_id: value.facility_id,
            })
        })
        setPatientOptions(results)
    }

    const getNextWorkingDays = () => {
        const workingDays = [];
        let currentDate = new Date();
        const todayLabel = `${currentDate.toLocaleDateString('en-US', { weekday: 'long' })} (${formatDate(currentDate)})`;
        workingDays.push({
            label: todayLabel,
            value: `${String(currentDate.getMonth() + 1).padStart(2, '0')}/${String(currentDate.getDate()).padStart(2, '0')}/${currentDate.getFullYear()}`
        });
        currentDate.setDate(currentDate.getDate() + 1);
        while (workingDays.length < 5) {
            const day = currentDate.getDay();
            if (day !== 0 && day !== 6) {
                let label = `${currentDate.toLocaleDateString('en-US', { weekday: 'long' })} (${formatDate(currentDate)})`;
                workingDays.push({
                    label,
                    value: `${String(currentDate.getMonth() + 1).padStart(2, '0')}/${String(currentDate.getDate()).padStart(2, '0')}/${currentDate.getFullYear()}`
                });
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return workingDays;
    };


    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: '2-digit',
        });
    };


    const handleQtyChange = (drugName, maxQty, value) => {
        const numericValue = parseFloat(value);

        if (isNaN(numericValue) || numericValue <= 0) {
            setEditableQuantities((prev) => ({
                ...prev,
                [drugName]: ""
            }));
        } else if (numericValue > maxQty) {
            toast.error(`Quantity cannot exceed ${maxQty}`, { autoClose: 2000 });
            setEditableQuantities((prev) => ({
                ...prev,
                [drugName]: maxQty.toString()
            }));
        } else {
            setEditableQuantities((prev) => ({
                ...prev,
                [drugName]: value
            }));
        }
    };


    async function fetchData(pid) {
        let tokenStr = localStorage.getItem("accessToken");
        setFormData((prev) => ({
            ...prev,
            patient_id: state?.patientid + ""
        }));
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/orders/list-refill-prescriptions/" + pid, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        let objData = data.prescriptions
        let results = [];
        objData.map((value) => {
            results.push({
                name: value.drug,
                rxNumber: value.pharmacy_order_id != null ? value.pharmacy_order_id : 0,
                qty: value.qty ? parseFloat(value.qty) : 0
            })
        })
        setDrugOptions(results)
    }

    const handleDrugSelection = (drug) => {
        if (!selectedDrugs.some((selected) => selected.name === drug.name)) {
            setSelectedDrugs([...selectedDrugs, drug]);
            setDrugOptions(drugOptions.filter((value) => value.rxNumber !== drug.rxNumber));

            setEditableQuantities((prev) => ({
                ...prev,
                [drug.rxNumber]: drug.qty.toString()
            }));
        }
    };

    const handleRemoveDrug = (drug) => {
        setSelectedDrugs(selectedDrugs.filter((selected) => selected.name !== drug.name));
        drugOptions.push(drug)
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setUploadedFile(file);
    };

    const handleFieldChange = (e) => {
        const value = e.target.value;
        setOrderTypeValue(value);
        setDocFlag(value === "3" || value === "4" || value === "5" || value === "6");

        setFormData((prev) => ({
            ...prev,
            order_type: value
        }));
        setErrors((prev) => ({
            ...prev,
            order_type: ""
        }));
    };

    const validateForm = () => {
        let newErrors = {};
        const type = parseInt(orderTypeValue);

        if (!selectedPatient.value) {
            newErrors.patient = "Patient is required.";
        }

        if (!orderTypeValue) {
            newErrors.order_type = "Order Type is required.";
        }

        if (selectedDate === "") {
            newErrors.delivery_date = "Delivery Date is required.";
        }

        if (formData.orderstatus === "") {
            newErrors.orderstatus = "Order Status is required.";
        }

        const typesWithDrugs = [1, 2, 4, 7, 8];

        if (typesWithDrugs.includes(type)) {
            if (type === 4 && !newDrug.trim()) {
                newErrors.newDrug = "Please enter the new drug name.";
            } else if (type !== 4 && selectedDrugs.length === 0) {
                newErrors.selectedDrugs = "Please select at least one drug.";
            }
        }

        // "Other" → only note required
        if (type === 3 && note.trim() === "") {
            newErrors.note = "Please enter a note.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    async function handleSubmit(e) {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);

        const type = parseInt(orderTypeValue);
        let payload = {
            patient_id: selectedPatient.value,
            delivery_date: selectedDate,
            order_type: orderTypeValue,
            note: note,
            order_status: formData.orderstatus,
            delivery_type: deliveryTypeOptions.find(
                (typeOption) => Number(typeOption.value) === Number(formData.deliveryOn || "1")
            ).value,
        };

        if (type !== 4 && selectedDrugs.length > 0) {
            payload.prescriptions = JSON.stringify(
                selectedDrugs.map((drug) => ({
                    rx_number: drug.rxNumber,
                    quantity: editableQuantities[drug.rxNumber] || drug.qty,
                }))
            );
        }

        if (type === 4) {
            payload.new_drug = newDrug.trim();
        }

        const submissionData = new FormData();
        Object.keys(payload).forEach((key) => {
            submissionData.append(key, payload[key]);
        });

        try {
            const tokenStr = localStorage.getItem("accessToken");
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/orders/create-prescription-order/`,
                submissionData,
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );

            if (response.data.status) {
                toast.success("Prescription Order added successfully");
                resetForm();

                // reload page
                if(formData.orderstatus !== "1") {
                    window.location.reload();
                }                    

            } else {
                toast.info("Error occurred while adding/updating Prescription Order.");
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    }


    const handleFileChange = (files) => {
        setUploadedFile(files);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // const handleOptionSelect = (selectedOption) => {
    //     setSelectedFacility(selectedOption);
    //     // setPatientOptionsFinal(filteredPatients);

    //     fetchPatientsData(selectedOption.value);
    // };

    const handlePatientSelection = (selectedOption) => {
        setSelectedPatient(selectedOption);
        // setPatientOptionsFinal(filteredPatients);
        setSelectedPatientFlag(true);
        setSelectedFacility(facilitiesData?.find((facility) => Number(facility.value) === Number(selectedOption.facility_id)));
        fetchData(selectedOption.value);
    };

    const handleOrderStatusChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            orderstatus: e.target.value
        }));
    };

    const resetForm = () => {
        setDrugOptions([]);
        setSelectedDrugs([]);
        setNewDrug("");
        setNote("");
        setEditableQuantities({});
        setFormData({
            patient_id: state?.patientid,
            delivery_date: '',
            order_type: '',
            note: '',
            orderstatus: '1',
            order_document: {},
            deliveryOn: '1',
            prescriptions: []
        });
        setOrderTypeValue('');
        setErrors({});
        setSelectedFacility({});
        setPatientOptions([]);
        setSelectedPatient({ name: 'Select Patient', id: '' });
        setSelectedPatientFlag(false);
        setDeliveryDates([]);
        setSelectedDate('');
        setShow(false);
        setLoading(false);
    };

    const loadOptions = async (inputValue) => {
        if (!inputValue) return [];

        try {
            const tokenStr = localStorage.getItem("accessToken");
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/patients/search-patient`,
                { search: inputValue },
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );

            const data = response.data.data.map((item) => ({
                value: item.id,
                label: `${item.last_name}, ${item.first_name}`,
                facility_id: item.facility_id,
            }));

            setPatientOptions(data); // optional if you need to store elsewhere
            return data; // IMPORTANT: return the options to show in dropdown
        } catch (error) {
            console.error("Error loading patients:", error);
            return [];
        }
    };


    return (
        <Modal onHide={resetForm} show={show} size="lg">
            <Modal.Header closeButton>
                <Modal.Title as="h5">ADD Order</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-body-tertiary p-4">
                <Form onSubmit={handleSubmit}>
                    <Row className='mb-3'>
                        <Col>
                            <Form.Group>
                                <Form.Label>Order Status</Form.Label>
                                <Form.Select
                                    name="orderstatus"
                                    onChange={handleOrderStatusChange}
                                    errorFlag={!!errors.orderstatus}
                                >
                                    {orderStatusList.map((order) => {
                                        return (
                                            <option key={order.value} value={order.value}>
                                                {order.key}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                                {errors.orderstatus && <small className="text-danger">{errors.orderstatus}</small>}
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Delivery On</Form.Label>
                                <Form.Select
                                    name="deliveryOn"
                                    onChange={handleInputChange}
                                    errorFlag={!!errors.deliveryOn}
                                >
                                    {deliveryTypeOptions?.map((type) => (
                                        <option key={type.value} value={type.value}>
                                            {type.label}
                                        </option>
                                    ))}
                                </Form.Select>
                                {errors.deliveryOn && <small className="text-danger">{errors.deliveryOn}</small>}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Label className="required">Patient</Form.Label>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={loadOptions}
                                value={selectedPatient}
                                defaultOptions={patientOptions}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                onChange={handlePatientSelection}
                                placeholderText="Type to search..."
                                styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: theme === 'dark' ? '#2d2f38' : '#fff',
                                        color: theme === 'dark' ? '#f8f9fa' : '#212529',
                                        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
                                        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
                                        '&:hover': {
                                            borderColor: '#80bdff'
                                        }
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        backgroundColor: theme === 'dark' ? '#2d2f38' : '#fff',
                                        zIndex: 5
                                    }),
                                    option: (provided, { isFocused, isSelected }) => ({
                                        ...provided,
                                        backgroundColor: isSelected
                                            ? theme === 'dark' ? '#3a3b3f' : '#e9ecef'
                                            : isFocused
                                                ? theme === 'dark' ? '#44464e' : '#f1f1f1'
                                                : theme === 'dark' ? '#2d2f38' : '#fff',
                                        color: theme === 'dark' ? '#f8f9fa' : '#212529',
                                        cursor: 'pointer',
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: theme === 'dark' ? '#f8f9fa' : '#212529'
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: theme === 'dark' ? '#adb5bd' : '#6c757d'
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        color: theme === 'dark' ? '#f8f9fa' : '#212529'
                                    }),
                                    dropdownIndicator: (provided, state) => ({
                                        ...provided,
                                        color: theme === 'dark' ? '#adb5bd' : '#495057',
                                        '&:hover': {
                                            color: '#80bdff'
                                        }
                                    }),
                                    indicatorSeparator: (provided) => ({
                                        ...provided,
                                        backgroundColor: theme === 'dark' ? '#44464e' : '#ced4da'
                                    }),
                                }}

                            />
                        </Col>
                    </Row>
                    {selectedPatientFlag &&
                        <>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Label>Facility</Form.Label>
                                    <Form.Control type="text" value={selectedFacility?.key} readOnly />
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col xs={6}>
                                    <Form.Label className="required">Delivery Date</Form.Label>
                                    <Form.Select name="selectdeliverydate" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)}>
                                        {deliveryDates.map((date, index) => (
                                            <option key={index} value={date.value}>{date.label}</option>
                                        ))}
                                    </Form.Select>
                                    {errors.delivery_date && <small className="text-danger">{errors.delivery_date}</small>}
                                </Col>
                                <Col>
                                    <Form.Label className="required">Order Type</Form.Label>
                                    <Form.Select name="ordertype" value={orderTypeValue} onChange={handleFieldChange}>
                                        {orderType.map((type) => (
                                            <option key={type.value} value={type.value}>{type.label}</option>
                                        ))}
                                    </Form.Select>
                                    {errors.order_type && <small className="text-danger">{errors.order_type}</small>}
                                </Col>
                            </Row>
                        </>
                    }

                    {[1, 2, 7, 8].includes(parseInt(orderTypeValue)) && (
                        <>
                            <Row className="mt-3">
                                <Col>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="outline-secondary" className='w-50'>Select drug to order</Dropdown.Toggle>
                                        <Dropdown.Menu className='w-50' style={{ maxHeight: "200px", overflowY: "auto" }}>
                                            {drugOptions.map((drug, index) => (
                                                <Dropdown.Item key={index} onClick={() => handleDrugSelection(drug)}>{drug.name}</Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    {errors.selectedDrugs && <small className="text-danger">{errors.selectedDrugs}</small>}
                                </Col>
                            </Row>
                            {selectedDrugs.length > 0 && (
                                <>
                                    <Row className="mt-4">
                                        <Col xs={5} sm={6} md={6}>
                                            <Form.Label>Drug Name</Form.Label>
                                        </Col>
                                        <Col xs={3} sm={2} md={2}>
                                            <Form.Label>Rx Number</Form.Label>
                                        </Col>
                                        <Col xs={3} sm={3} md={3}>
                                            <Form.Label>Qty</Form.Label>
                                        </Col>
                                        <Col>
                                            {/* <Form.Label>Remove</Form.Label> */}
                                        </Col>
                                    </Row>

                                    {selectedDrugs.map((drug, index) => (
                                        <Row key={index} className="mb-3 align-items-center">
                                            <Col xs={5} sm={6} md={6}>
                                                <Form.Control type="text" value={drug.name} readOnly />
                                            </Col>
                                            <Col xs={3} sm={2} md={2}>
                                                <Form.Control type="text" value={drug.rxNumber} readOnly />
                                            </Col>
                                            <Col xs={3} sm={3} md={3}>
                                                <Form.Control
                                                    type="number"
                                                    min="1"
                                                    value={editableQuantities[drug.rxNumber] ?? drug.qty}
                                                    placeholder="Enter Qty"
                                                    onChange={(e) =>
                                                        handleQtyChange(drug.rxNumber, drug.qty, e.target.value)
                                                    }
                                                />
                                            </Col>
                                            <Col className="mt-1">
                                                <Col
                                                    className="badge bg-primary text-white cursor-pointer"
                                                    onClick={() => handleRemoveDrug(drug)}
                                                >
                                                    ×
                                                </Col>
                                            </Col>
                                        </Row>
                                    ))}
                                </>
                            )}
                        </>
                    )}
                    {parseInt(orderTypeValue) === 4 && (
                        <Row className="mb-3">
                            <Col>
                                <Form.Label className="required">New Drug Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter new drug name"
                                    value={newDrug}
                                    onChange={(e) => setNewDrug(e.target.value)}
                                />
                                {errors.newDrug && <small className="text-danger">{errors.newDrug}</small>}
                            </Col>
                        </Row>
                    )}
                    {orderTypeValue && (
                        <Row className="mb-3">
                            <Col>
                                <Form.Label>
                                    Notes {parseInt(orderTypeValue) === 3 && <span className="text-danger"> (Required)</span>}
                                </Form.Label>
                                <Form.Control as="textarea" rows={1} value={note} onChange={(e) => setNote(e.target.value)} />
                                {errors.note && <small className="text-danger">{errors.note}</small>}
                            </Col>
                        </Row>
                    )}

                    <Row className="mb-3">
                        <Col md={12}>
                            <Form.Label className="text-danger text-center fw-bold">
                                *Please call pharmacy for urgent or after hours deliveries.
                            </Form.Label>
                        </Col>
                    </Row>
                    <Row className='d-flex justify-content-center'>
                        <Button type="submit"
                            color="primary"
                            name="addordermodalsubmit"
                            className='w-25'
                            disabled={loading}>
                            {loading ? <Spinner size="sm" animation="border" /> : "Submit"}
                        </Button>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddOrderDetailModal;
